export default __webpack_public_path__ + "static/media/icon-reviews.77607648.svg";